import { Collection } from 'modules/core/lib/mobx-rest'

import JobRoleAnalytics from 'modules/job_catalog/store/models/JobRoleAnalytics'

class JobRoleAnalyticsCollection extends Collection<JobRoleAnalytics> {
  get cacheKey(): string {
    return 'jobRoleAnalytics'
  }

  model() {
    return JobRoleAnalytics
  }
}

const singleton = new JobRoleAnalyticsCollection()

export default singleton
